export default {
  path: 'fifo',
  component: () => import('../../views/admin/fifoChecker/product/index.vue'),
  children: [
    {
      path: '',
      component: () => import(/* webpackChunkName: "fifoChecker" */ '../../views/admin/fifoChecker/product/inventoryMovementFifoCheckerList.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.fifoChecker.product.title'
        // rule: 'editor'
      }
    },
    {
      path: 'inventory-movement',
      name: 'inventoryMovement',
      component: () => import(/* webpackChunkName: "inventoryMovement" */ '../../views/admin/fifoChecker/product/inventoryMovementFifoCheckerList.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.fifoChecker.product.title'
        // rule: 'editor'
      }
    },
    {
      path: 'purchase-lot',
      name: 'purchaseLot',
      component: () => import(/* webpackChunkName: "purchaseLot" */ '../../views/admin/fifoChecker/product/purchaseLotFifoCheckerList.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.fifoChecker.product.title'
        // rule: 'editor'
      }
    },
    {
      path: 'sale-cost-allocation',
      name: 'saleCostAllocation',
      component: () => import(/* webpackChunkName: "saleCostAllocation" */ '../../views/admin/fifoChecker/product/saleCostAllocationFifoCheckerList.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.fifoChecker.product.title'
        // rule: 'editor'
      }
    },
    {
      path: 'sale-return-allocation',
      name: 'saleReturnAllocation',
      component: () => import(/* webpackChunkName: "saleReturnAllocation" */ '../../views/admin/fifoChecker/product/saleReturnAllocationFifoCheckerList.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.fifoChecker.product.title'
        // rule: 'editor'
      }
    }
  ]
}
